import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
const Gallery = () => {
  // Sample images with unique ids and different src/alt values
  const images = [
    { id: 2, src: '/images/keyword/1.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/3.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/23.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/6.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/7.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/8.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/10.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/11.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/12.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/13.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/14.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/15.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/16.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/17.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/18.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/19.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/20.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/21.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/24.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/keyword/25.jpg', alt: 'Image 2' },

    { id: 2, src: '/images/g1.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g2.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g3.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g5.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g6.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g7.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g8.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g9.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g10.jpg', alt: 'Image 2' },
    { id: 2, src: '/images/g11.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/home.jpg', alt: 'Image 3' },
    { id: 3, src: '/images/home1.jpg', alt: 'Image 3' },
    { id: 3, src: '/images/home2.jpg', alt: 'Image 3' },
    { id: 3, src: '/images/home9.jpg', alt: 'Image 3' },
    { id: 3, src: '/images/ww5.jpg', alt: 'Image 3' },
    { id: 3, src: '/images/ww4.jpg', alt: 'Image 3' },

  
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };



  return (

<>

<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Gallery</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
         

    
    <div className="gallery-container  ">
      <div className="gallery-grid ">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderr"
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay border">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container ">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>

</>
  );
};

export default Gallery;